module.exports = __webpack_public_path__ + "media/images/icons/star-35ddbc22da44bc3f427217a14c4e3606.png";